/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type InternalCheckStatusIdv =
  typeof InternalCheckStatusIdv[keyof typeof InternalCheckStatusIdv];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalCheckStatusIdv = {
  PASS: 'PASS',
  NOT_VALIDATED: 'NOT_VALIDATED',
  INCONCLUSIVE: 'INCONCLUSIVE',
} as const;
